import WorldIcon from 'components/ReusableComponents/Icons/World'
import { useInternalAdmin } from 'hooks'
import { useSelector } from 'react-redux'

import { ReactComponent as HubspotIcon } from './hubspot.svg'

const HeaderChecklist = () => {
  const isGdsBookingAvailable = useSelector(s => s.hotelDetails.isGdsBookingAvailable)
  const hubspotId = useSelector(s => s.hotelDetails.hubspotId)
  const isInternalAdmin = useInternalAdmin()

  return (
    <>
      <WorldIcon
        fill={isGdsBookingAvailable ? '#66bb6a' : '#b7babf'}
        width="27px"
        height="27px"
        style={{ position: 'releative', top: '0', marginRight: 6 }}
        title="GDS Booking is available"
      />
      {isInternalAdmin && (
        <>
          {hubspotId && (
            <a
              href={`https://app.hubspot.com/contacts/3397857/record/0-2/${hubspotId}`}
              target="_blank"
              rel="noreferrer"
              style={{ height: 27 }}
            >
              <HubspotIcon
                fill="#ff7a59"
                width="27px"
                height="27px"
                style={{ position: 'releative', top: '0', marginRight: 12 }}
                title="Hubspot is connected"
              />
            </a>
          )}
          {!hubspotId && (
            <HubspotIcon
              fill="#ff7a59"
              width="27px"
              height="27px"
              style={{
                position: 'releative',
                top: '0',
                marginRight: 12,
                filter: 'grayscale(100%)',
                opacity: 0.7
              }}
              title="Hubspot is connected"
            />
          )}
        </>
      )}
    </>
  )
}

export default HeaderChecklist
